angular.module("env.exceptions", [])

    // Any uncaught exception in angular expressions is delegated to this service
    // For root exceptions handling with `window.onerror` check vendor/exception-catcher
    .factory("$exceptionHandler", function ($injector, $localStorage) {

        function toLocalStorage(exception) {

            if (!exception || (!exception.stack && !exception.message && !_.isString(exception))) {
                return;
            }
            var messageToLocalStorage = (new Date()).toLocaleTimeString() + ' ' + (exception.stack || exception.message || exception);

            var oldErrors;
            try {
                oldErrors = $localStorage.getItem("errors");
            } catch (e) {
                oldErrors = [];
            }
            if (!oldErrors || !_.isArray(oldErrors)) {
                oldErrors = [];
            }
            oldErrors = oldErrors.slice(-100);
            oldErrors.push(messageToLocalStorage);
            $localStorage.setItem("errors", oldErrors);
        }

        return function (exception, cause) {
            var $log = $injector.get("$log", "$exceptionHandler");

            try {
                if (exception && cause) {
                    if (!exception.message) {
                        exception.message = "Unknown error";
                    }
                    exception.message += " (caused by '" + cause + "')";
                }

                // to local storage
                toLocalStorage(exception);

                // add to log
                $log.error("Unexpected error in angular expressions!", exception);
            } catch (e) {
                $log.error("We were unable to handle root angular error!", e);
                $log.error("More information about angular error:", error);
            }

            // and raise toast
            try {
                // resolve toastr on runtime to prevent circular module dependency
                var toastr = $injector.get("toastr");
                var gettextCatalog = $injector.get("gettextCatalog");

                var msg = gettextCatalog.getString("An error report has been logged on our server."),
                    header = gettextCatalog.getString("Unexpected error!");
                toastr.error(msg + ' <div style="text-align:right;"><a target="_blank" href="#/error">Details</a></div>', header);
            } catch (ex) {
                $log.warn("Can't raise toast!", ex);
            }
        };

    })
;
